module.exports = __webpack_public_path__ + "static/WEDDING E&M-128-817b76eca0d2f12157bfc155597d1852.jpg";